<template src='./digitalWalletBalance.pug' lang='pug'></template>

<script>
import moment from 'moment'
import MultiSelectModal from '../../../modals/multiSelectModal/MultiSelectModal'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import FormSearch from '../../../form/formSearch/FormSearch'
import DateRange from '../../../input/dateRange/DateRange'
import BetterInputTag from '../../../input/betterInputTag/BetterInputTag'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import TreeGrid from '../../../treeGrid/TreeGrid'
import axios from '../../../../../build/http-requests/axios-common.js'
import { EXPORT_TREEGRID } from '../../../../../build/jsonToExcel/exportRoutes.js'
import language from '../../../../../build/language/index'
import { startTreeGridLoading, stopTreeGridLoading } from '../../../../utils/grid-load-transition.js'
import selectTag from '../../../../events/selectTag'

export default {
  name: 'DigitalWalletBalance',

  components: {
    MultiSelectModal,
    PageTitle,
    FilterPortlet,
    FormSearch,
    DateRange,
    BetterInputTag,
    ButtonPrimary,
    TreeGrid
  },

  data () {
    return {
      inputTagsProps: {
        digitalWallets: {
          id: 'id',
          name: 'nome'
        }
      },
      data: {
        digitalWallets: {
          titles: {
            main: this.$t('saldoCarteiraDigital.labels.carteirasDigitais'),
            sub: this.$t('saldoCarteiraDigital.labels.selecionarCarteirasDigitais')
          },
          selectedItems: [],
          columns: ['nome'],
          values: [],
          options: {
            columnsClasses: { nome: 'col-md-12' },
            perPage: 5,
            headings: {
              nome: this.$t('saldoCarteiraDigital.labels.nome')
            },
            filterable: ['nome'],
            filterByColumn: true,
            perPageValues: [],
            texts: {
              count: this.$t('dataTable.labels.contagem'),
              noResults: this.$t('dataTable.labels.semResultados'),
              filterBy: '',
              filterPlaceholder: this.$t('dataTable.labels.filtrar')
            },
            sortable: ['nome'],
            sortIcon: {
              is: ''
            },
            pagination: { chunk: 5 },
            orderBy: {
              ascending: true,
              column: 'nome'
            },
            customSorting: {
              nome: (asc) => {
                return (a, b) => {
                  if (asc) {
                    return a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
                  }
                  return b.nome.toLowerCase().localeCompare(a.nome.toLowerCase())
                }
              }
            },
            templates: {
              nome: (h, row) => {
                return row.nome
              }
            }
          }
        }
      },
      shown: {
        digitalWallets: false
      },
      defaultTags: {
        digitalWallets: [{
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }]
      },
      gridId: '#SaldoCarteiraDigital',
      treeGridCfg: {},
      DIGITAL_WALLET_MODAL: 'digitalWalletsModal',
      audit: {},
      dateRange: {},
      digitalWalletsSelected: [],
      digitalWalletsTags: [this.$t('inputTag.labels.todos')],
      firstDate: new Date(),
      finalDate: new Date(),
      finalDateDisable: moment(new Date()).add(10, 'years').toDate(),
      showTreegrid: false,
      exportUrl: EXPORT_TREEGRID,
      filter: {
        entityId: null
      },
      result: {},
      treeGridFileName: 'SaldoCarteiraDigital',
      error: false,
      msgError: '',
      disableSearchButton: false,
      idsItensSelected: []
    }
  },

  methods: {
    validate () {
      const self = this
      return new Promise(resolve => {
        self.$validator.validateAll().then((result) => {
          if (result && self.$refs.dateRange.validate()) {
            self.showTreegrid = true
            startTreeGridLoading(self.gridId)
            self.search().finally(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
      })
    },

    search () {
      this.disableSearchButton = true
      let filter = {
        inicio: this.dateRange.fromDate,
        fim: this.dateRange.toDate,
        idsCategorias: this.data.digitalWallets.selectedItems.map(selected => selected.id).filter(categories => categories !== '-1'),
        lang: language.getCookieByName('language')
      }

      return new Promise((resolve, reject) => {
        axios.post('/digitalWalletBalance/', { filter: filter }).then((response) => {
          if (window.Grids[0]) {
            window.DisposeGrids()
          }
          this.result = response.data
          this.treeGridCfg = response.data.Cfg.Layout
          this.showTreegrid = true
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
          resolve()
        }).catch((error) => {
          this.$root.$refs.notification.error(error)
          stopTreeGridLoading(this.gridId)
          this.disableSearchButton = false
          reject()
        })
      })
    },

    openSelectDigitalWalletsModal () {
      if (this.data.digitalWallets.values.length > 0) {
        this.shown.digitalWallets = true
        return
      }
      this.$store.dispatch('getCategories', {
        url: '/digitalWalletBalance/loadCategories',
        flTipoCategoria: 'W',
        validarUso: false
      })
        .then((response) => {
          this.data.digitalWallets.values = response.data
          this.shown.digitalWallets = true
        })
    },

    closeModal () {
      this.shown.digitalWallets = false
    }
  },

  mounted () {
    selectTag.$on('tagsSelected', (tags, idsItensSelected) => {
      this.digitalWalletsTags = tags
      this.idsItensSelected = idsItensSelected
    })
  }
}
</script>

<style lang='css' scoped>
.input-button>button {
  margin: 24px 0 0 0;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  float: left;
}

#logDeAuditoriaWrapper {
  width: 100%;
}

#divTreeGridAuditoria {
  min-width: 100%;
  min-height: 500px;
}

.check {
  text-align: center;
}

.filterButton {
  width: 3vw;
  margin: 0px !important;
}

.col-search {
  width: 53.5%;
}

.search-button {
  min-width: 7vw;
}
</style>



// WEBPACK FOOTER //
// DigitalWalletBalance.vue?f2d73540